import { Block, TextBlockWithAttachment } from '~/protos/agents'
import { AbsReactiveBlock } from './AbsReactiveBlock'

export class ReactiveTextBlock extends AbsReactiveBlock {
  constructor(block: TextBlockWithAttachment) {
    super()
    this.onSelect = this.onSelect.bind(this)
    this._block = Block.fromPartial({
      textBlockWithAttachment: block
    })
  }

  public onSelect(options: string[]) {
    if (this._block.textBlockWithAttachment) {
      this._block.textBlockWithAttachment.text = options.join(', ')
    }
  }
}
